<template>
    <v-container>
        <v-row v-if="mmsReady">
            <v-list>
                <v-list-item class="d-flex align-center" @click="item.value=!item.value;sendControl(item.cmd,item.value)" v-for="(item,index) in jboardSettings" :key="index">
                  <v-checkbox class="mt-0 py-0 ml-0" :input-value="item.value" hide-details>
                    <template v-slot:label>
                        <span style="margin-left:8px;margin-bottom:0px;">{{item.text}}</span>
                    </template>
                  </v-checkbox>
                </v-list-item>
            </v-list>
        </v-row>
        <v-row v-if="!mmsReady" justify="center">
            <v-progress-circular indeterminate size="30"></v-progress-circular>
        </v-row>
    </v-container>
</template>
<script>
import conf from "@/config/config";
export default {
    name:"JBSettings",
    data(){
        return {
            qname:this.$route.query.qname,
            ddn:this.$route.query.ddn,
            json:null,
            errorMsg: "",
            from:this.$route.query.from,
            EiName:this.$route.query.EiName,
            errorLoading: false,
        }
    },
    props:['mms','mmsReady','jboardSettings'],
    mixins:[],
    created(){
        
    },
    computed:{
    },
    watch:{
        mmsReady:{
            async handler(val){
               
            },
            immediate:true
        }, 
    },
    methods:{
        async sendControl(cmd,...args){
            let reply =await this.mms.sendMMS({
                        topic: '',
                        DDN:`ddn/${this.ddn}`,
                        payload: {'qname':this.qname,'cmd':cmd,'value':args?args[0]:undefined}
                });
            console.log(reply);
        },
        checkWebMMSState(){
            if(!this.mmsReady)
            {
              this.errorMsg = "WebMMS is not connected or registered.";
              this.errorLoading = true;
              return false;
            }else return  true;

        },
        
    }
}
</script>